import React from 'react';

interface PageTitleProps {
  title: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title }) => {

  return (
    <h3 style={{
      textAlign: 'left',
      display: 'block',
      marginLeft: '10px',
      marginBottom: '20px'
    }}>
      {title}
    </h3>
  );
};

export default PageTitle;
